import { LogicOperator, Role } from '@okletsplay/core';
import { useRoles } from 'modules/auth/hooks';
import React, { FC, useMemo } from 'react';

export const withRoles =
  <T,>(Component: FC<T>, roles: Role[], logicOperator: LogicOperator = LogicOperator.OR) =>
  ({ ...props }: T): JSX.Element | null => {
    const { hasAnyRole, hasAllRoles } = useRoles();

    let isRenderAllowed = false;
    if (logicOperator === LogicOperator.OR) {
      isRenderAllowed = useMemo(() => hasAnyRole(roles), [hasAnyRole]);
    } else if (logicOperator === LogicOperator.AND) {
      isRenderAllowed = useMemo(() => hasAllRoles(roles), [hasAllRoles]);
    }

    return isRenderAllowed ? <Component {...props} /> : null;
  };
